<template>
  <div>
    <app-header>
      <template #title>
        <h1 class="d-inline me-4">{{ opportunity.formatted_name }}</h1>
        <span v-bind:class="getStatusColor(opportunity.status)" class="status">{{ opportunity.status }}</span>
      </template>
    </app-header>

    <div class="layout-sidesheet row" style="height: calc(100vh - 75px)">
      <div class="col main-content">
        <ul id="horizontal-nav" class="nav nav-horizontal sticky-top" style="position: sticky">
          <router-link tag="li" class="nav-item" :to="{ name: 'opportunities.overview' }">
            <a class="nav-link">Overview</a>
          </router-link>

          <router-link tag="li" class="nav-item" :to="{ name: 'opportunities.costing' }">
            <a class="nav-link">Costing</a>
          </router-link>

          <router-link tag="li" class="nav-item" :to="{ name: 'opportunities.quote' }">
            <a class="nav-link">Quote</a>
          </router-link>

          <router-link
            tag="li"
            class="nav-item"
            :to="{
              name: 'opportunities.document-signing',
              params: { sign_request_id: opportunity.sign_request.id },
            }"
            v-if="opportunity.sign_request"
          >
            <a class="nav-link">
              <i class="fas fa-signature" />
              Document Signing
            </a>
          </router-link>
        </ul>
        <!-- /#horizontal-nav -->

        <router-view v-if="loaded" @refresh="loadOpportunity"></router-view>
      </div>

      <notes v-if="loaded"></notes>
    </div>
  </div>
</template>

<script>
import { http } from 'utils'
import { mapState, mapActions } from 'vuex'
import { cloneDeep } from 'lodash'
import Multiselect from 'vue-multiselect'
import { helperMethods } from 'vx/modules/clients'
import { echo } from 'mixins'
import Notes from 'components/notes/Notes.vue'

export default {
  $_veeValidate: {
    validator: 'new', // give me my own validator scope.
  },

  mixins: [echo],

  components: {
    Multiselect,
    Notes,
  },
  data: function () {
    return {
      editOpportunity: null,
      types: ['S1', 'S2', 'T&M', 'CON'],
      statuses: ['Draft', 'Sent', 'Approved'],
      client: null,
      loaded: false,
      quoteGenerating: false,
    }
  },
  computed: {
    ...mapState('opportunity', {
      opportunity: 'single',
    }),
  },
  watch: {
    '$route.params.opportunity_id': function (newId, oldId) {
      this.loadData()
      this.echo.leave('channel-opportunity-' + oldId)
    },
  },

  created() {
    this.echoConnect()
  },

  mounted: function () {
    this.loadData()
  },

  beforeDestroy: function () {
    this.echo.leave('channel-opportunity-' + this.opportunity.id)
    this.echoDisconnect()
  },

  methods: {
    ...helperMethods,
    ...mapActions('opportunity', {
      getOpportunity: 'getSingle',
      setOpportunityProperty: 'setSingleProperty',
    }),
    ...mapActions('costing', ['getCosting']),
    ...mapActions('templates', ['getTemplates']),
    ...mapActions('userStoryDocument', ['getUserStoryDocument']),
    ...mapActions('notes', { setNotesStateProperty: 'setStateProperty' }),

    connectChannels() {},

    loadData() {
      this.echo
        .private('channel-opportunity-' + this.$route.params.opportunity_id)
        .listen('newPandaDocCreatedBroadcast', (e) => {
          this.setOpportunityProperty({
            property: 'quote.uuid',
            value: e.quote.uuid,
          })
          this.quoteGenerating = false
          this.$router.push({
            name: 'opportunities.panda',
            params: { opportunity_id: this.opportunity.id },
          })
        })

      this.loadOpportunity()
    },
    loadOpportunity() {
      this.getOpportunity(this.$route.params.opportunity_id).then(() => {
        this.editOpportunity = cloneDeep(this.opportunity)

        Promise.all([
          this.setClient(this.editOpportunity.client),
          this.getCosting(this.editOpportunity.user_story_document_id),
          this.getUserStoryDocument(this.editOpportunity.user_story_document_id),
          //this.getProject(this.opportunity.project_id),
          this.getTemplates(),
          this.setNotesStateProperty({ property: 'parent', value: 'opportunity' }),
        ]).then(() => {
          this.loaded = true
        })
      })
    },
    downloadDraftPDF() {
      var link = `${process.env.VUE_APP_API_URL}/user-story-document/${
        this.user_story_document.id
      }/export/draft?token=${auth.getToken()}&tags=${this.withTags ? 1 : 0}&name=${this.fileName}`
      window.open(link)
    },
    getGrumpGoat() {
      return process.env.VUE_APP_API_URL + '/../images/grumpy-goat.png'
    },
    generateQuote() {
      this.quoteGenerating = true

      http
        .post(
          `/opportunities/${this.opportunity.id}/generateQuote`,
          {},
          {
            responseType: 'arraybuffer',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/pdf',
            },
          }
        )
        .then((response) => {
          if (this.$route.name == 'opportunities.panda') {
            this.$router.push({
              name: 'opportunities.overview',
              params: { opportunity_id: this.opportunity.id },
            })
          }
        })
    },
    sendForSigning() {
      this.quoteGenerating = true

      http
        .post(
          `/opportunities/${this.opportunity.id}/sendForSigning`,
          {},
          {
            responseType: 'arraybuffer',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/pdf',
            },
          }
        )
    },
    getStatusColor(status) {
      switch (status) {
        case 'Draft':
          return 'status-default'
          break
        case 'Sent':
          return 'status-info'
          break
        case 'Pending Approval':
          return 'status-warning'
          break
        case 'Approved':
          return 'status-info'
          break
        case 'Viewed':
          return 'status-primary'
          break
        case 'Declined':
          return 'status-warning'
          break
        case 'Signed':
          return 'status-success'
          break
        case 'Expired':
          return 'status-danger'
          break
      }
    },
  },
}
</script>
